import { render, staticRenderFns } from "./list-item-row.vue?vue&type=template&id=a09112dc&"
import script from "./list-item-row.vue?vue&type=script&lang=js&"
export * from "./list-item-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports